var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"店主信息"},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_vm._l((_vm.infos),function(info){return _c('p',[_vm._v(_vm._s(info))])}),_c('template',{slot:"footer"},[_c('a-button',{key:"submit",attrs:{"type":"primary"},on:{"click":_vm.handleOk}},[_vm._v(" 确定 ")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }